export class ColumnDefinition {
  name: string;
  label: string;
  visible: boolean;
  sortable: boolean;
  draggable: boolean;
  /** 'liveness' renders <cosmos-measurement-liveness-badge>; reads `row.measurementType` and the last entry of `row.time`. */
  type?: string;
  tag?: boolean;
  /** For tag=true: maps cell value → PrimeNG severity ('success'|'warn'|'danger'|'info'|'secondary') */
  tagColorMap?: Record<string, "success" | "secondary" | "info" | "warn" | "danger" | "contrast" | null | undefined>;
  /** For tag=true: i18n key prefix prepended to the raw cell value for display, e.g. 'analytics.processingJob.status.' */
  tagTranslatePrefix?: string;
  /** For type='translate': i18n key prefix prepended to the raw cell value, e.g. 'concretes.methods.maturity.'. When absent, the raw cell value is used as the full translation key (legacy behavior). */
  translatePrefix?: string;
  footer?: any;
  tooltip?: boolean;
  rightBorder?: boolean;
};

export class ActionDefinition {
  name: string;
  label: string;
  icon: string;
  iconAction?: string;
  sticky: boolean;
  role?: string;
}

export interface FilterDefinition {
  /** Query param key sent to the backend (e.g. 'name', 'isDistributor') */
  name: string;
  /** i18n label key */
  label: string;
  /** Controls which input is rendered in the filter panel */
  type: 'text' | 'boolean' | 'select' | 'objectId' | 'dateRange';
  /** For type='select': static list of options with pre-translated labels */
  options?: { label: string; value: any }[];
  /**
   * For type='select': i18n key prefix. Each option's label becomes
   * `${translatePrefix}${value}` at render time, e.g. 'constants.device.status.stock'.
   * Use this instead of pre-translated `options` when values map 1:1 to translation keys.
   */
  translatePrefix?: string;
  /** For type='select' with translatePrefix: the raw values to build options from */
  values?: string[];
  /** Disables the filter input */
  disabled?: boolean;
  /** Tooltip shown when the filter is disabled (i18n key) */
  disabledTooltip?: string;
}
